/**
 * klaviyo-forms.js
 * Intercepta todos los formularios de newsletter del tema y envía
 * el email a Klaviyo (_learnq) antes de que Shopify procese el submit.
 * Compatible con: shared-site-footer, footer estándar, sección newsletter,
 * email-signup-banner y cualquier otro formulario con contact[tags]=newsletter.
 */
(function () {
  'use strict';

  // Seleccionamos por el input oculto — así funciona con cualquier
  // formulario de newsletter del tema, sin importar su ID o clase.
  var NEWSLETTER_SELECTOR = 'form input[name="contact[tags]"][value="newsletter"]';

  function getEmail(form) {
    var input = form.querySelector('input[type="email"][name="contact[email]"]');
    return input ? input.value.trim() : '';
  }

  function pushToKlaviyo(email) {
    window._learnq = window._learnq || [];
    window._learnq.push(['identify', { $email: email }]);
  }

  function attachListener(hiddenInput) {
    var form = hiddenInput.closest('form');
    if (!form || form._klaviyoReady) return;
    form._klaviyoReady = true;

    form.addEventListener('submit', function () {
      var email = getEmail(form);
      if (email) pushToKlaviyo(email);
      // El submit de Shopify continúa con normalidad
    });
  }

  function init() {
    document.querySelectorAll(NEWSLETTER_SELECTOR).forEach(attachListener);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
